import { gql } from '__generated__';

const GetParticipantDetailsQuery = gql(`
  query GetParticipantDetails($project_id: ID!, $participant_id: ID!) {
    project(id: $project_id) {
      id
      participant(id: $participant_id) {
        id
        email
        first_name
        last_name
        full_name
        phone
        emergency_phone
        gender
        date_of_birth
        age
        nationality
        street
        house_number
        zip_code
        city
        extra_address_line
        country
      }
    }
  }
`);

export default GetParticipantDetailsQuery;
